export default {
  name: 'WeibyCounter',
  props: {
    max: {
      default: 99,
      type: [Number, String],
    },
    min: {
      default: 0,
      type: [Number, String],
    },
    step: {
      default: 1,
      type: Number,
    },
    value: {
      default: 0,
      type: [Number, String],
    },
  },
  data() {
    return {
      count: 0,
    };
  },
  watch: {
    count(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal, oldVal) {
      if (+newVal !== +oldVal) {
        this.count = +newVal <= +this.max ? +newVal : this.max;
      }
    },
  },
  created() {
    this.count = +this.value || +this.min;
  },
  methods: {
    filterOnlyNumberAndLengthSmallerThanMaxLength($event = {}) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      const maxLength = String(this.max).length;
      const isMinus = String.fromCharCode(keyCode) === '-';
      const preventMinus = +this.min < 0 ? isMinus : false;
      const allowedKeys = !preventMinus
        && (keyCode < 48 || keyCode > 57)
        && (keyCode !== 8 || keyCode !== 46);

      const value = $event.target?.value;
      if (allowedKeys || value?.length >= maxLength) {
        $event.preventDefault();
      }
      this.count = $event?.target?.value?.replace(/^0+/, '');
    },
    onAddCount() {
      const result = +this.count + this.step;
      this.count = result > this.max ? this.max : result;
    },
    onMinusCount() {
      const result = +this.count - this.step;
      this.count = result < this.min ? this.min : result;
    },
    setIfEmptyValue() {
      if (!this.count) {
        this.count = 0;
      }
    },
  },
};
